<template>
	<div class="main">
	    <div>
			<div class="search" style="background: white;padding:20px;margin-top: 30px;">
				<el-row>
					<el-form  :model="search" label-width="80px">
						<div style="float: left;">
							<el-form-item label="标签名">
								<el-input v-model="search.name"  placeholder="请输入标签名"></el-input>
							</el-form-item>
						</div>
						<div style="float: left;margin-left: 20px;">
							 <el-button type="primary" @click="SelectSearch">搜索</el-button>
						</div>
					</el-form>
				</el-row>
			</div>
			<div style="height:30px"></div>
			<div style="width: 100%;background: white;padding-top:2.5%">
				<div style="text-align: left;padding-bottom: 2.5%;padding-left: 2.5%;">
					<el-button size="mini" @click="add()" type="primary" ><i class="el-icon-plus"></i>新增	</el-button>
				</div>
				<div class="table">
					<el-table border :data="tableData" row-key="uuid" style="width: 95%;margin-left: 2.5%;" >
						<el-table-column label="标签名" prop="name">
						</el-table-column>
						<el-table-column label="属性名" prop="property">
						</el-table-column>
						<el-table-column align="center" >
						  <template slot-scope="scope">
							<el-button size="mini"
							    @click="handleEdit(scope.$index, scope.row)" type="primary"><i class="el-icon-edit"></i>修改</el-button>
							<el-button size="mini"
							  @click="handleDelete(scope.$index, scope.row)" type="danger"><i class="el-icon-edit"></i>删除</el-button>
						  </template>
						</el-table-column>
					  </el-table>
				</div>
			</div>
			
			<div class="page" style="padding:30px;text-align: right;background: white;">
				<div class="block">
					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  :page-sizes="[10, 50, 100, 200]"
					  :page-size="search.page"
					  layout="sizes, prev, pager, next"
					  :total="search.total">
					</el-pagination>
				  </div>
			</div>
		</div>
		<edit v-if="edit_show" @close="CloseDialog" :id="id"></edit>
	</div>
</template>

<script>
import edit from '../components/goodsnorms/Edit.vue'
export default{
	name:'GoodsClassify',
	components:{
		edit
	},
	data(){
		return {
			search:{
				name:"",
				page:1,
				limit:10,
			},
			tableData:[],
			edit_show:false,
		}
	},
	methods:{
		add(){
			this.id="";
			this.edit_show = !this.edit_show;
		},
		handleEdit(index, row) {
			this.id=row.uuid;
			this.edit_show = !this.edit_show;
		},
		// FlowhandleEdit(index, row){
		// 	this.id=row.uuid;
		// 	this.flow_edit_show = !this.flow_edit_show;
		// },
		handleDelete(index, row) {
			var self=this;
			this.$confirm('删除该数据, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
				var url="/index/GoodsNorms/Delete";
				self.$post(url,{"uuid":row.uuid}).then(function(res){
					if(res.errCode=="1"){
						self.$success(res,self);
						self.SelectSearch()
					}else{
						self.$error(res,self);
					}
				})
			});
		},
		file_show(val){
			this.dialogImageUrl = val;
			this.img_show = true;
		},
		handleSizeChange(val){
			this.search.limit=val
			this.SelectSearch()
		},
		handleCurrentChange(val){
			this.search.page=val
			this.SelectSearch()
		},
		async SelectSearch(){
			let res=await this.$get("/index/GoodsNorms/GetList",this.search)
			this.tableData=res.result.data
			this.search.total=res.result.total
		},
		CloseDialog(){
			this.edit_show=false;
			this.flow_edit_show=false;
			this.SelectSearch()
		}
	},
	mounted() {
		this.SelectSearch()
	}
}
</script>

<style>
</style>
